import type { AppState } from 'types/app';

export const selectMeta = (state: AppState) => state?.meta;

export const selectDocumentMeta = (state: AppState) => selectMeta(state)?.documentMeta;
